import * as req from 'api/actions';
import * as c from './constant';

export const getServiceList = (payload, callback) =>
  req.list(
    c.GET_SERVICE,
    'api/v1/administrators/e_wallet_services_menu',
    payload,
    callback
  );

export const showService = (id, payload, callback) =>
  req.item(
    c.SHOW_SERVICE,
    `api/v1/administrators/e_wallet_services_menu/${id}`,
    payload,
    callback
  );

export const updateService = (id, payload, callback) =>
  req.update(
    c.UPDATE_SERVICE,
    `api/v1/administrators/e_wallet_services_menu/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearService = () => req.setList(c.GET_SERVICE, []);

export const createService = (payload, callback) =>
  req.create(
    c.CREATE_SERVICE,
    `api/v1/administrators/e_wallet_services_menu`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeService = (id, payload, callback) =>
  req.remove(
    c.REMOVE_SERVICE,
    `api/v1/administrators/e_wallet_services_menu/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
